module.exports = __webpack_public_path__ + "static/media/male.fab99538.png";